import React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100000000;
`;

const Modal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  z-index: 1000000000;
  width: 400px;
`;

const ModalHeader = styled.div`
  font-size: 20px;
  text-align: center;
  font-weight: bold;
  margin-bottom: 20px;
`;

const ModalBody = styled.div`
  padding: 10px 10px;
  border: 1px solid #ddd;
  border-radius: 10px;
  min-height: 100px;
`;

const ModalFooter = styled.div`
  margin-top: 20px;
  text-align: center;
`;

const CloseButton = styled.button`
  padding: 8px 16px;
  font-size: 14px;
  border: none;
  background-color: #85c1a9;
  color: white;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #76b093;
  }
`;

interface ModalPopupProps {
  title: string;
  body: string;
  onClose: () => void;
}

const DeletedReasonPopup: React.FC<ModalPopupProps> = ({
  title,
  body,
  onClose,
}) => {
  return (
    <>
      <Overlay onClick={onClose} />
      <Modal>
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>{body}</ModalBody>
        <ModalFooter>
          <CloseButton onClick={onClose}>닫기</CloseButton>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default DeletedReasonPopup;
